import { useForm } from "react-hook-form";
import { Button, InputField } from "../../../components/forms";
import  Datepicker  from "../../../components/generic/Datepicker";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { addressRegex, emailReg, numReg, textReg } from "../../../utils/regex";
import { countries } from "../../../constant/data";
import { useSelector } from "react-redux";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { GoPlus } from "react-icons/go";
import { FaCircle, FaSave, FaUsers } from "react-icons/fa";
import Filepicker from "../../../components/generic/Filepicker";
import { FiPlusCircle } from "react-icons/fi";
import Switch from "react-switch";
import { useEffect, useState } from "react";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import Subordinates from "./Subordinates";
import {
  onGetSubordinates,
  ToggleIsLineManager,
} from "../../../services/employee";
import { toast } from "react-toastify";
import ReasignSubordinates from "../../../components/Modules/Employees/ReasignSubordinates";
import usePositionHook from "../../../hooks/usePositionHook";
import { IoMdCheckbox } from "react-icons/io";
import { FaRegCalendarDays } from "react-icons/fa6";
import { IoReceipt } from "react-icons/io5";
import History from "./History";

export default ({ details }: any) => {
  const dateofbirthPick = usePickerhook();
  var { control, handleSubmit, watch } = useForm();
  const departmentPickhook = usePickerhook();
  const countrypicked = usePickerhook();
  const [showreasign, setshowreasign] = useState(false);
  const { setSidebarRenderView, setselectedEmpl, setLoading } =
    useStateSetter();
  const [subordinates, setsubordinates] = useState([]);
  const { AddPosition, refresh, allorgPositions } = usePositionHook();
  const [islinemanager, setislinemanager] = useState(false);
  const [startdates, setstartdates] = useState([]);
  const [enddates, setenddates] = useState([]);

  const { SelectedOrg, selectedEmployee, config } = useStateGetter();
  const getSubs = async () => {
    try {
      setLoading(true);

      var response = await onGetSubordinates(selectedEmployee.id, config);
      setsubordinates(response.data);
    } catch (e: any) {
      toast.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setstartdates(selectedEmployee.lineMangerStartDate?.split(","));
    setenddates(selectedEmployee.lineMangerEndDate?.split(","));
  }, [selectedEmployee]);
  useEffect(() => {
    if (selectedEmployee.isLineManager) {
      getSubs();
    }
  }, [selectedEmployee.isLineManager]);
  return (
    <div>
      {showreasign && (
        <ReasignSubordinates
          AddPosition={AddPosition}
          allorgPositions={allorgPositions}
          refresh={getSubs}
          subordinates={subordinates}
          show={setshowreasign}
        />
      )}

      {selectedEmployee.isLineManager && (
        <div className="w-full border rounded-lg  flex justify-between items-center px-2 border-gray-300 my-2 py-4">
          <div>
            <p className="text-xs flex  items-center gap-2 ">
              <span className="text-gray-800  font-semibold text-sm">
                Manager 
              </span> 
              <FaCircle className="text-yellow-600 " /> assigned
            </p>
{/* 
            <p className="font-light text-xs cursor-pointer flex gap-2 justify-center items-center">
              <FaRegCalendarDays className="text-textbg inline  " />
              {`${startdates[0]}  - ${enddates[0]}`}

              <FaUsers className="text-textbg inline  " />
              {subordinates.length}
            </p> */}
          </div>

          <p 
          onClick={()=>{
            setSidebarRenderView(<History enddates={enddates} startdates={startdates} />);

          }}
           className="text-primary text-xs font-semibold cursor-pointer ">
            View History
          </p>
        </div>
      )}
      <div className=" grid grid-cols-2 gap-4 mb-4 	 ">
        <ListPicker
          fullwidth
          hook={departmentPickhook}
          title="Position"
          list={[]}
        />
        <ListPicker
          fullwidth
          hook={departmentPickhook}
          title="Department"
          list={[]}
        />
        <ListPicker
          fullwidth
          hook={departmentPickhook}
          title="Manager"
          list={[]}
        />

        <Datepicker
          defaultvalue={{ code: new Date(), name: new Date().toDateString }}
          hook={dateofbirthPick}
          title="Eployment date"
        />
      </div>
      <div className=" flex items-center justify-between text-xs">
        <div className="flex  items-center">
          <p className="text-textbg font-semibold text-sm inline  ">
            Line Manager Role
          </p>
          <Switch
            checkedIcon={false}
            uncheckedIcon={false}
            offColor="#EAECF5"
            onColor="#CB0E5F"
            className="m-4"
            onChange={async () => {
              if (selectedEmployee.isLineManager) {
                setshowreasign(true);
              }
              let postdata = {
                employeeID: selectedEmployee.id,
              };
              try {
                setLoading(true);
                var res = await ToggleIsLineManager(postdata, config);
                setselectedEmpl(res.data);
              } catch (e: any) {
                toast.error(e);
              } finally {
                setLoading(false);
              }
            }}
            checked={selectedEmployee.isLineManager}
          />
        </div>
        <div>
          {selectedEmployee.isLineManager && (
            <p className="font-semibold">
              Subordinate ({subordinates.length}){" "}
              <span
                onClick={() => {
                  setSidebarRenderView(<Subordinates />);
                }}
                className="text-primary cursor-pointer  "
              >
                {" "}
                View
              </span>
            </p>
          )}
        </div>
      </div>
      <div></div>
      <div className=" grid grid-cols-2 gap-4 mb-4">
        <ListPicker
          fullwidth
          hook={departmentPickhook}
          title="Workings hours"
          list={[]}
        />
        <Filepicker title={"Resume/CV"} />
      </div>
      <div>
        <p className="text flex font-semibold  gap-4  ">
          Certification{" "}
          <FiPlusCircle className={"inline text-primary"} size={20} />{" "}
          <span className="text-primary">Add</span>
        </p>

        <div className="grid grid-cols-2 gap-4 ">
          <InputField
            name="certname"
            title="Certificate name"
            placeholder={"Certificate name"}
            control={control}
            rules={{
              required: "Certificate name is required",
              pattern: {
                value: textReg,
                message: "Invalid Certificate name",
              },
            }}
          />
          <Filepicker title={"File"} />
        </div>
      </div>
      <div>
        <p className="text flex font-semibold  gap-4  ">
          Skills <FiPlusCircle className={"inline text-primary"} size={20} />{" "}
          <span className="text-primary">Add</span>
        </p>

        <div className="grid grid-cols-2 gap-4 ">
          <ListPicker
            fullwidth
            hook={departmentPickhook}
            title="Select skill type"
            list={[]}
          />
          <ListPicker
            fullwidth
            hook={departmentPickhook}
            title="Select skill levle"
            list={[]}
          />
        </div>
      </div>
      <div className="w-full  flex justify-end items-center">
        <Button
          width={200}
          disabled={true}
          text={
            <>
              {" "}
              <FaSave size={15} className=" mx-1 inline" /> Save Changes
            </>
          }
          onBtnClick={() => {}}
        />
      </div>
    </div>
  );
};
